import React from 'react';

const WhyProkraya = ({ 
  imageUrl = "https://www.freepik.com/free-photo/representation-user-experience-interface-design_94963717.htm#fromView=search&page=1&position=4&uuid=41a31771-9e8a-4e7c-a5ba-0df2b0e6c2ee&query=working+software+analytiucs+%2C+chatrs",
  title = "Why choose Prokraya?",
  description = "Productivity can be improved with more constructive and concentrated decisions. Prokraya helps you consolidate all your spends, direct as well as indirect, and helps in elevating your procurement team's performance to a whole new level. Prokraya is an array of procurement solutions interlinked with each other, eliminating the need for separate stand-alone modules and enhancing its reach and impact on the business."
}) => {
  return (
    <div className="bg-white mb-10">
   

      {/* Main Content */}
      <div className="container mx-auto px-6 py-2">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <h1 className="text-3xl lg:text-3xl font-bold text-gray-900 leading-tight text-black">
              {title}
            </h1>
            
            <p className="text-lg text-gray-600 max-w-xl  ">
              {description}
            </p>
          </div>

          {/* Right Image */}
          <div className="lg:ml-8">
            <div className="relative">
              <img 
                src='https://www.freepik.com/free-photo/representation-user-experience-interface-design_94963717.htm#fromView=search&page=1&position=4&uuid=41a31771-9e8a-4e7c-a5ba-0df2b0e6c2ee&query=working+software+analytiucs+%2C+chatrs'
                alt="Professional working at desk"
                className="w-full h-auto rounded-lg shadow-lg object-cover"
                style={{ maxHeight: '500px' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyProkraya;